import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['date']

  connect() {
    this.localize()
  }

  localize() {
    const el = this.dateTarget
    const utcString = el.dataset.utcTime
    if (!utcString) return

    const date = new Date(utcString)

    const dateOptions = {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }
    const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true }

    const localizedDate = date.toLocaleDateString('en-US', dateOptions)
    const localizedTime = date.toLocaleTimeString('en-US', timeOptions)

    const parts = new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short'
    }).formatToParts(date)
    const tzName = parts.find(part => part.type === 'timeZoneName').value

    el.textContent = `${localizedDate} | ${localizedTime} ${tzName}`
  }
}
